import { ClockIcon } from '@mm/icons';
import { Moment } from 'moment';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useBotAnalyticsCRUDActions } from '@mm/state/actions/BotAnalyticsCRUDActions';
import { selectAvgAgentResponseTime } from '@mm/state/selectors/botAnalyticsSelector';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { Heading } from '@mm/components';
import './AvgTime.scss';

type Props = {
  startDate: Moment | null;
  endDate: Moment | null;
  dateRangeMode: string | null;
};

export const AvgResponseTime = (props: Props) => {
  const { startDate, endDate, dateRangeMode } = props;
  const avgAgentResponseTime = useSelector(selectAvgAgentResponseTime);
  const { retrieveAvgAgentResponseTime } = useBotAnalyticsCRUDActions();
  const activeChatbotId = useSelector(activeChatbotIdSelector);

  useEffect(() => {
    retrieveAvgAgentResponseTime(
      activeChatbotId,
      startDate?.format('YYYY-MM-DD'),
      endDate?.format('YYYY-MM-DD'),
    );
  }, [startDate, endDate]);

  return (
    <div className="average-time">
      <Heading size={3} text="Avg Response Time" />
      <div className="average-time__date">
        <span className="average-time__date-show">Show: </span>
        {dateRangeMode ? dateRangeMode : 'Custom date range'}
      </div>
      <div className="average-time__time-container">
        <ClockIcon className="average-time__clock-icon" />
        {avgAgentResponseTime} min
      </div>
    </div>
  );
};
